// Competitor comparison pages at /alternatives/:competitor. The words live in
// public/locales/<lang>/compare.json under the slug (page_title, tagline, positioning,
// strengths, weaknesses, prices, comparison table, switch_reasons, screenshots[{alt,
// caption}] in the order of `screenshots` here, faq). Pricing sourced from each
// vendor's official pricing page; last reviewed against SITE_LAST_UPDATED. Where data
// is uncertain we keep the (verify) marker so future updates know to double-check.

export const alternatives = {
  airtable: {
    slug: 'airtable',
    name: 'Airtable',
    screenshots: ['/screenshots/documents/database.png', '/screenshots/home/main.png'],
  },

  monday: {
    slug: 'monday',
    name: 'Monday.com',
    screenshots: ['/screenshots/projects/kanban.png', '/screenshots/habits/main.png'],
  },
};

const asList = (v) => (Array.isArray(v) ? v : []);

/** A comparison in the reader's language: the config above with its words (t of a useTranslation that loads 'compare'). */
export const getAlternative = (slug, t) => {
  const config = alternatives[slug];
  if (!config) return null;
  const c = t(`compare:${slug}`, { returnObjects: true });
  const text = c && typeof c === 'object' ? c : {};
  const shots = asList(text.screenshots);
  return {
    slug: config.slug,
    name: config.name,
    pageTitle: text.page_title,
    seoTitle: text.seo_title,
    seoDescription: text.seo_description,
    keywords: text.keywords,
    tagline: text.tagline,
    positioning: text.positioning,
    strengths: asList(text.strengths),
    weaknesses: asList(text.weaknesses),
    free_tier: text.free_tier,
    paid_from: text.paid_from,
    busybee_paid_from: text.busybee_paid_from,
    comparison: { title: text.comparison?.title, columns: asList(text.comparison?.columns), rows: asList(text.comparison?.rows) },
    best_for: text.best_for,
    switch_reasons: asList(text.switch_reasons),
    screenshots: config.screenshots.map((src, i) => ({ src, ...shots[i] })),
    faq: asList(text.faq),
  };
};
export const allAlternatives = (t) => Object.keys(alternatives).map((slug) => getAlternative(slug, t));
